import { Pipe, PipeTransform } from '@angular/core';
import { Resource } from '@klickdata/core/resource';
import { Utils } from '@klickdata/core/util';
import * as moment from 'moment';

@Pipe({
    name: 'resourceRegistrationInfo',
})
export class ResourceRegistrationInfoPipe implements PipeTransform {
    grey = '#b6b6b6';
    orange = '#ff9961';
    red = '#e44a66';
    white = '#fff';
    darkblue = '#3e5365';
    green = '#bfd8d0';
    iceblue = '#93cbd1';

    transform(resource: Resource): {
        borderColor?: string;
        label: string;
        backgroundColor?: string;
        details?: string;
        disabled?: boolean;
    } {
        const metadata = resource.user_collaboration?.enroll_approval_required?.metadata;
        if (!metadata || resource.user_collaboration?.enroll_approval_required.status)
            return {
                borderColor: this.green,
                label: $localize`Open`,
                backgroundColor: this.green,
            };
        if (resource.user_enrollment.approval_status == 'pending') {
            return {
                borderColor: this.orange,
                label: $localize`Pending Approval`,
                backgroundColor: this.orange,
                disabled: true,
            };
        }
        if (resource.user_enrollment.approval_status == 'rejected') {
            return {
                borderColor: this.red,
                label: $localize`Request Rejected`,
                backgroundColor: this.red,
                disabled: true,
            };
        }
        if (resource.user_enrollment.approval_status == 'approved') {
            return {
                borderColor: this.green,
                label: $localize`Approved`,
                backgroundColor: this.green,
                disabled: true,
            };
        }

        // if the resource is during the application period
        if (metadata.occasion_dates.length > 0 && Utils.isResourceDuringApplicationPeriod(metadata.occasion_dates)) {
            return {
                borderColor: this.green,
                label: $localize`Open to`,
                details: moment(Utils.getResourceLastApplication(metadata.occasion_dates).application_end_date).format(
                    'YYYY-MM-DD'
                ),
                backgroundColor: this.green,
            };
        }
        // if the resource is not during the application period and has future occasion
        if (
            !Utils.isResourceDuringApplicationPeriod(metadata.occasion_dates) &&
            Utils.isResourceHasFutureOccasion(metadata.occasion_dates)
        ) {
            return {
                borderColor: this.grey,
                label: $localize`Not available`,
                details:
                    $localize`Open` +
                    ' ' +
                    moment(Utils.getResourceLastApplication(metadata.occasion_dates).application_end_date).format(
                        'YYYY-MM-DD'
                    ),
                backgroundColor: this.white,
                disabled: true,
            };
        }
        // if the resource is not during the application period
        if (!Utils.isResourceDuringApplicationPeriod(metadata.occasion_dates)) {
            return {
                borderColor: this.red,
                label: $localize`Registration closed`,
                backgroundColor: this.red,
                disabled: true,
            };
        }
    }
}
